/**
 * ClipArt Queries
 */
import gql from 'graphql-tag'

export const clipArtsQuery = gql`
  query GetClipArts($query: String) {
    clipArts: getCliparts(query: $query) {
      id
      url
      category
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterCustomize/SymbolTab/data.ts